export default __webpack_public_path__ + "static/media/Armguards of Reckless Challenge.8df408ed.jpg";